import Quill from 'quill';
import { RICH_TEXT_INLINE_ACTIONS } from '../../../../../constants/markdown';
const BlockEmbed = Quill.import('blots/block/embed');

class InlineActionBlot extends BlockEmbed {
  static blotName = 'inlineAction';
  static tagName = 'div'; // We prevent the RTE to automatically wrap it to <p> tag
  static className = 'inline-action-wrapper';

  // The value here is the key of an inline action
  static create(value) {
    let node = super.create();
    node.setAttribute('contenteditable', 'false');

    const inlineActionData = Object.values(RICH_TEXT_INLINE_ACTIONS)?.find(action => action.key === value);

    // Set the tooltip content in a data attribute
    if(inlineActionData?.tooltip) {
      node.setAttribute('data-tooltip', inlineActionData.tooltip);

    }

    let span = document.createElement('span');
    span.innerText = inlineActionData?.displayText || '/';
    span.className = 'inline-action-text';

    node.appendChild(span);
    return node;
  }
}

Quill.register(InlineActionBlot);
export default InlineActionBlot;
